export default {
      id: "settings-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#settings",
      toString: function () {
        return this.url;
      }
    }